import React from "react"
import { DynamicTag } from "@/components/Default/Title/DynamicTag"


const Title = ({ data = {} }) => {
  const { appliedCssClassNames = "", text = "" } = data
  return (
    <div
      className={`title ${appliedCssClassNames ? appliedCssClassNames : ""}`}
    >
      <div className="cmp-title">
        <DynamicTag type = {data?.type} className="cmp-title__text">{text} </DynamicTag>
      </div>
    </div>
  )
}

export default Title
